import { useEffect, useRef } from 'react'

// Hook
const usePrevious = <T,>(value: T): T => {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class
  const ref: any = useRef<T>(undefined)
  // Store current value in ref
  useEffect(() => {
    ref.current = value
  }, [JSON.stringify(value)]) // Only re-run if value changes
  // Return previous value (happens before update in useEffect above)
  return ref.current
}

export default usePrevious
